/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Location } from './Location';
import type { SaleFulfillmentSummaryDto } from './SaleFulfillmentSummaryDto';
import type { SalesOrderCharge } from './SalesOrderCharge';
import type { SalesOrderDiscount } from './SalesOrderDiscount';
import type { SalesOrderInstallment } from './SalesOrderInstallment';
import type { SalesOrderItem } from './SalesOrderItem';
import type { SalesOrderPayment } from './SalesOrderPayment';
import type { SalesOrderReceipt } from './SalesOrderReceipt';
import type { SalesOrderTax } from './SalesOrderTax';
import type { User } from './User';
export type SalesOrder = {
  /**
   * Unique sales order identifier
   */
  id: number;
  /**
   * Unique order code
   */
  orderCode: string;
  /**
   * Per-branch receipt number for client-specific numbering (e.g. VEV-3482). Null when disabled.
   */
  branchReceiptCode?: string | null;
  /**
   * Associated location
   */
  location: Location;
  /**
   * User who created the order
   */
  createdBy: User;
  /**
   * Customer profile
   */
  customer?: Record<string, any>;
  /**
   * Order status
   */
  status: SalesOrder.status;
  /**
   * Mixed-branch logistics progress, independent of payment status
   */
  fulfillmentStatus: SalesOrder.fulfillmentStatus;
  /**
   * Customer handoff progress, independent of payment and logistics
   */
  deliveryStatus: SalesOrder.deliveryStatus;
  /**
   * Whether this order already incremented customer purchase counters
   */
  customerPurchaseCounted: boolean;
  /**
   * Mixed-sale logistics progress counters (list views only)
   */
  fulfillmentSummary?: SaleFulfillmentSummaryDto | null;
  /**
   * Sales channel
   */
  salesChannel: SalesOrder.salesChannel;
  /**
   * Priority level
   */
  priorityLevel: SalesOrder.priorityLevel;
  /**
   * Has discount applied
   */
  hasDiscount: boolean;
  /**
   * Discount scope
   */
  discountScope?: SalesOrder.discountScope;
  /**
   * Has partial payment
   */
  hasPartialPayment: boolean;
  /**
   * Partial payment scope
   */
  partialPaymentScope?: SalesOrder.partialPaymentScope;
  /**
   * Has installments
   */
  hasInstallments: boolean;
  /**
   * Installments frequency
   */
  installmentsFrequency?: SalesOrder.installmentsFrequency;
  /**
   * Subtotal before discounts
   */
  subtotal: number;
  /**
   * Total discount amount
   */
  discountAmount: number;
  /**
   * Subtotal before tax
   */
  subtotalBeforeTax: number;
  /**
   * Total with tax
   */
  totalWithTax?: number;
  /**
   * Total order amount
   */
  totalAmount: number;
  /**
   * Total extra charges amount
   */
  extraChargesTotal: number;
  /**
   * Whether the order has extra charges
   */
  hasExtraCharges: boolean;
  /**
   * Whether the sale includes an external manual invoice (internal tracking only)
   */
  hasInvoice: boolean;
  /**
   * Whether the seller explicitly confirmed a zero-price sale (courtesy / gift)
   */
  confirmZeroSale: boolean;
  /**
   * Commercial order type
   */
  orderType: SalesOrder.orderType;
  /**
   * Total cost of products
   */
  totalCost: number;
  /**
   * Profit margin percentage
   */
  profitMargin: number;
  /**
   * Order notes
   */
  orderNotes?: string;
  /**
   * Customer notes
   */
  customerNotes?: string;
  /**
   * Estimated completion date
   */
  estimatedCompletion?: string;
  /**
   * Last payment date
   */
  lastPaymentDate?: string;
  /**
   * Next payment due date
   */
  nextPaymentDue?: string;
  /**
   * Commercial sale date (business date of the transaction)
   */
  saleDate: string;
  /**
   * Creation timestamp
   */
  createdAt: string;
  /**
   * Last update timestamp
   */
  updatedAt: string;
  /**
   * Order items
   */
  items: Array<SalesOrderItem>;
  /**
   * Order receipts
   */
  receipts: Array<SalesOrderReceipt>;
  /**
   * Order payments
   */
  payments: Array<SalesOrderPayment>;
  /**
   * Order installments (future / UI inactive). No product_movement_history events until the feature is enabled.
   */
  installments: Array<SalesOrderInstallment>;
  /**
   * Order taxes (future)
   */
  taxes: Array<SalesOrderTax>;
  /**
   * Order discounts
   */
  discounts: Array<SalesOrderDiscount>;
  /**
   * Additional order-level charges
   */
  charges: Array<SalesOrderCharge>;
};
export namespace SalesOrder {
  /**
   * Order status
   */
  export enum status {
    DRAFT = 'DRAFT',
    CONFIRMED = 'CONFIRMED',
    PARTIAL_PAID = 'PARTIAL_PAID',
    PAID = 'PAID',
    DELIVERED = 'DELIVERED',
    CANCELLED = 'CANCELLED',
    REFUNDED = 'REFUNDED',
  }
  /**
   * Mixed-branch logistics progress, independent of payment status
   */
  export enum fulfillmentStatus {
    NOT_REQUIRED = 'NOT_REQUIRED',
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
    CANCELLED = 'CANCELLED',
  }
  /**
   * Customer handoff progress, independent of payment and logistics
   */
  export enum deliveryStatus {
    NONE = 'NONE',
    PARTIAL = 'PARTIAL',
    FULL = 'FULL',
    CANCELLED = 'CANCELLED',
  }
  /**
   * Sales channel
   */
  export enum salesChannel {
    IN_STORE = 'IN_STORE',
    ONLINE = 'ONLINE',
    PHONE = 'PHONE',
    WHATSAPP = 'WHATSAPP',
  }
  /**
   * Priority level
   */
  export enum priorityLevel {
    LOW = 'LOW',
    NORMAL = 'NORMAL',
    HIGH = 'HIGH',
    URGENT = 'URGENT',
  }
  /**
   * Discount scope
   */
  export enum discountScope {
    PER_ITEM = 'PER_ITEM',
    PER_ORDER = 'PER_ORDER',
  }
  /**
   * Partial payment scope
   */
  export enum partialPaymentScope {
    PER_ITEM = 'PER_ITEM',
    PER_ORDER = 'PER_ORDER',
  }
  /**
   * Installments frequency
   */
  export enum installmentsFrequency {
    MONTHLY = 'MONTHLY',
    WEEKLY = 'WEEKLY',
    BIWEEKLY = 'BIWEEKLY',
  }
  /**
   * Commercial order type
   */
  export enum orderType {
    SALE = 'SALE',
    SERVICE = 'SERVICE',
    CUSTOM = 'CUSTOM',
  }
}
